import { RouteRecordRaw } from 'vue-router'

export const ecommerceRoutes: Array<RouteRecordRaw> = [
  {
    name: 'ecommerce',
    path: '/ecommerce',
    component: () => import('../pages/ecommerce/EcommercePage.vue'),
    meta: {
      title: 'NexaConn Device Store',
    },
  },
  {
    name: 'product-details',
    path: '/ecommerce/product/:id',
    component: () => import('../pages/ecommerce/ProductDetails.vue'),
    meta: {
      title: 'Product Details',
    },
  },
]
